import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { CtbButtonComponent } from '@lepoleimmo/cost-to-build-client-ui-button';
import { CtbCarouselComponent } from '@lepoleimmo/cost-to-build-client-ui-carousel';
import { CtbEstimatorIntroductionComponent } from '@lepoleimmo/cost-to-build-client-ui-estimator-introduction';
import { CtbExpansionPanelComponent } from '@lepoleimmo/cost-to-build-client-ui-expansion-panel';
import { CtbLogoComponent } from '@lepoleimmo/cost-to-build-client-ui-logo';
import { CtbRadioGroupsComponent } from '@lepoleimmo/cost-to-build-client-ui-radio-groups';
import { CtbResumeComponent } from '@lepoleimmo/cost-to-build-client-ui-resume';
import { CtbSliderComponent } from '@lepoleimmo/cost-to-build-client-ui-slider';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RouterModule,
        CtbButtonComponent,
        CtbRadioGroupsComponent,
        CtbSliderComponent,
        CtbExpansionPanelComponent,
        CtbResumeComponent,
        CtbCarouselComponent,
        CtbEstimatorIntroductionComponent,
        CtbLogoComponent,
    ],
    selector: 'app-root',
    styleUrl: './app.scss',
    templateUrl: './app.html',
})
export class App {
    title = 'client';
    readonly #httpClient = inject(HttpClient);
    readonly helloWorld = toSignal(this.#httpClient.get<{ message: string }>('/api'), {
        initialValue: { message: 'loading...' },
    });

    myLabel = signal('Obtenir mon estimation');

    onButtonClick(): void {
        this.myLabel.set(new Date().toLocaleTimeString());
    }

    onCtbButtonClick(): void {}

    onCtbRadioButtonClick(): void {}

    valueChanged(event: string): void {
        // biome-ignore lint/suspicious/noConsole: <Temporary> For demonstration purposes
        console.log('Selected value:', event);
    }

    sliderValue(): void {
        // biome-ignore lint/suspicious/noConsole: <Temporary> For demonstration purposes
        console.log('Slider value changed:', event);
    }

    sliderValueChanged(event: unknown): void {
        // biome-ignore lint/suspicious/noConsole: <Temporary> For demonstration purposes
        console.log('Slider state changed:', event);
    }
}
